import React from 'react';
import ModalTypeEnum from 'Modals/ModalConstants';
import connectModal from 'Modals/enhancers/ConnectModal';
import BaseModal from 'Modals/BaseModal';
import ConnectedSignatureReminderModalBody from 'Modals/content/SignatureReminderBodyContent';

const FreeWriteSignatureReminderModalContainer = connectModal(
  BaseModal,
  'signatureReminderModal',
  {
    modalType: ModalTypeEnum.FREE_WRITE_SIGNATURE_REMINDER,
    bodyContent: (
      <ConnectedSignatureReminderModalBody
        modalType={ModalTypeEnum.FREE_WRITE_SIGNATURE_REMINDER}
      />
    ),
    footerButtons: false,
    trackFreeWrite: true,
    ariaLabel: 'Signature Reminder Modal',
    includeHeaderCloseButton: false,
    preventClickingOutside: true,
  },
);

export default FreeWriteSignatureReminderModalContainer;



// WEBPACK FOOTER //
// ./src-react/Modals/containers/FreeWriteSignatureReminderModal/index.jsx